import React, {useEffect} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import moment from 'moment/moment'

//verifier si un objet est vide ou pas
const isEmpty = (obj) => Object.keys(obj).length === 0

const PrixPieceMarcherModal = ({data}) => {
  return (
    <>
      <div className='modal fade' tabIndex={-1} id='detailsPrixModal'>
        <div className='modal-dialog' style={{maxWidth: '1600px', width: '95%'}}>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>Détails du prix</h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                data-bs-target='#modal_details_cat'
                data-bs-toggle='modal'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body table-responsive'>
              {/* begin::Table */}
              <table className='table align-middle text-center table-row-dashed table-row-gray-300 gy-7'>
                {/* begin::Table head */}
                <thead>
                  <tr className='fw-bold text-muted'>
                    <th className='min-w-140px'>Référence constructeur</th>
                    <th className='min-w-140px'>Prix min 1</th>
                    <th className='min-w-140px'>Prix min 2</th>
                    <th className='min-w-140px'>Prix min 3</th>
                    <th className='min-w-140px'>Prix max 1</th>
                    <th className='min-w-140px'>Prix max 2</th>
                    <th className='min-w-140px'>Prix max 3</th>
                    <th className='min-w-140px'>Prix moyen 1</th>
                    <th className='min-w-140px'>Prix moyen 2</th>
                    <th className='min-w-140px'>Prix moyen 3</th>
                    <th className='min-w-140px'>Prix moyen total</th>
                    <th className='min-w-140px'>Total pièce</th>
                    <th className='min-w-140px'>Prix constructeur scrapping</th>
                    <th className='min-w-140px'>Date scrapping</th>
                    <th className='min-w-140px'>Prix constructeur lacour</th>
                    <th className='min-w-140px'>Date lacour</th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody>
                  {!isEmpty(data) ? (
                    <tr key={data?.id}>
                      <td>
                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                          {data?.referenceConstructeur}
                        </p>
                      </td>
                      <td>
                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                          {data?.prixMin1}
                        </p>
                      </td>
                      <td>
                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                          {data?.prixMin2}
                        </p>
                      </td>
                      <td>
                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                          {data?.prixMin3}
                        </p>
                      </td>
                      <td>
                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                          {data?.prixMax1}
                        </p>
                      </td>
                      <td>
                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                          {data?.prixMax2}
                        </p>
                      </td>
                      <td>
                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                          {data?.prixMax3}
                        </p>
                      </td>
                      <td>
                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                          {data?.prixMoyen1}
                        </p>
                      </td>
                      <td>
                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                          {data?.prixMoyen2}
                        </p>
                      </td>
                      <td>
                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                          {data?.prixMoyen3}
                        </p>
                      </td>
                      <td>
                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                          {data?.prixMoyenTotal}
                        </p>
                      </td>
                      <td>
                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                          {data?.totalPiece}
                        </p>
                      </td>
                      <td>
                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                          {data?.prixConstructeur}
                        </p>
                      </td>
                      <td>
                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                          {data?.dateScrapping &&
                            moment(data?.dateScrapping).format('DD/MM/YYYY à HH:mm')}
                        </p>
                      </td>
                      <td>
                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                          {data?.prixConstructeurLacour}
                        </p>
                      </td>
                      <td>
                        <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                          {data?.dateLacour &&
                            moment(data?.dateLacour).format('DD/MM/YYYY à HH:mm')}
                        </p>
                      </td>
                    </tr>
                  ) : (
                    <tr className='min-w-140px'>
                      <td colSpan={18} className='text-center'>
                        Aucun résultat trouvé
                      </td>
                    </tr>
                  )}
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-light'
                data-bs-target='#modal_details_cat'
                data-bs-toggle='modal'
                data-bs-dismiss='modal'
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {PrixPieceMarcherModal}
